import { Children, cloneElement, useEffect } from 'react';

import { useConfigPutQuery } from '../../../Common/Queries/configQueries';
import { usePositionsGetQuery } from '../../../Common/Queries/positionsQueries';

import { isLogin } from '../../../utils';

import { ALL_DATA_LIMIT, DURATION_TIME } from '../../../constants';

const initialValues = { position: '', screeningTime: 0, remainderValue: 0 };

export function PositionScreeningTimeContainer({ children, setOpen, configData, ...props }) {
  const child = Children.only(children);
  const putToConfig = useConfigPutQuery();
  // const configData = useConfigGetQuery();

  const positionList = usePositionsGetQuery(
    { limit: ALL_DATA_LIMIT },
    { enabled: isLogin(), refetchInterval: DURATION_TIME, refetchIntervalInBackground: true }
  );

  function handleOnSubmitDefaultTime(req) {
    const reqParams = {
      ...configData?.data,
      automaticScreeningTime: {
        ...configData?.data?.automaticScreeningTime,
        default: req.defaultTime,
        default_remainder: req?.remainderValue,
      },
    };
    putToConfig.mutate(reqParams);
  }

  function handleOnSubmit(req) {
    const latestOverrides = configData?.data?.automaticScreeningTime?.overrides?.filter(
      ({ positionID }) => positionID !== req.positionID
    );

    const reqParams = {
      ...configData?.data,
      automaticScreeningTime: {
        ...configData?.data?.automaticScreeningTime,
        overrides: [...latestOverrides, req],
      },
    };
    putToConfig.mutate(reqParams);
  }

  useEffect(() => {
    if (putToConfig.isSuccess) setOpen(false);
  }, [putToConfig.isSuccess]);

  return cloneElement(child, {
    putToConfig,
    initialValues,
    handleOnSubmit,
    handleOnSubmitDefaultTime,
    selectedPositions: configData?.data?.automaticScreeningTime?.overrides?.map(
      ({ positionID }) => positionID
    ),
    ...props,
    positionList,
  });
}
